import classNames from 'classnames'
import React, { useState } from 'react'

interface Ipopup {
  menu: {
    value: string
    text: string
  }[]
  active: string
  onChange: (key: { value: string; text: string }) => void
  className?: string
}

const drop_down_arrow = require('static/drop-down-arrow.png')

export default function Popup(props: Ipopup) {
  const { menu, active, onChange, className } = props
  const [show, setShow] = useState(false)
  const activeItem = menu.find(({ value }) => value === active)

  const handleToggle = (command?: boolean) => {
    if (command !== undefined) {
      setShow(command)
      return
    }
    setShow(!show)
  }

  return (
    <div
      className={classNames(className, 'popup')}
      tabIndex={0}
      onBlur={() => handleToggle(false)}
    >
      <span className="current" onClick={() => handleToggle()}>
        {activeItem?.text}
        {menu.length > 1 && <img src={drop_down_arrow} />}
      </span>
      {show && menu.length > 1 && (
        <div className="menu">
          {menu.map(({ text, value }) => (
            <span
              className={classNames('item', {
                active: value === active,
              })}
              onClick={() => {
                handleToggle(false)
                onChange({ value, text })
              }}
              key={value}
            >
              {text}
            </span>
          ))}
        </div>
      )}
      <style jsx>
        {`
          .popup {
            position: relative;
            padding-bottom: 6px;
            display: inline-block;
            z-index: 1;
          }

          .popup:focus {
            outline: none;
          }
          .current {
            color: #1f2129;
            font-size: 18px;
            font-weight: 500;
            cursor: ${menu.length > 1 ? 'pointer' : 'default'};
            display: flex;
            align-items: center;
          }
          .current img {
            width: 14px;
            height: 14px;
            object-position: center;
            -o-object-fit: cover;
          }
          .menu {
            position: absolute;
            top: 28px;
            left: -16px;
            width: 120px;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            overflow: hidden;
            cursor: pointer;
            box-shadow: 0 10px 24px 0 rgba(31, 33, 41, 0.12);
          }
          .item {
            height: 49px;
            background-color: white;
            color: #606370;
            font-size: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .active {
            background-color: #ffebad;
            color: #1f2129;
            cursor: default;
            position: relative;
          }
        `}
      </style>
    </div>
  )
}
